module.exports = __webpack_public_path__ + "img/icon-upacp.e0b76ecc.svg";